import axios from 'axios';
import type { GetSuggestionLabelsParams, GetSuggestionOptionsParams } from '../types/api/definition';
import { transformations } from '../utils/transformationLayer';
import { AXIOS_BASE_CONFIG } from './axiosConfig';
import type { ApiContext } from './types';
const BASE_V4_DATAGRID_URL = `/v4/data-grid/`;
export function createSuggestionApi(ctx: ApiContext) {
  return {
    getSuggestionOptions: (params: GetSuggestionOptionsParams) => axios.get(`${BASE_V4_DATAGRID_URL}suggestion/${params.suggestId}/options`, {
      ...AXIOS_BASE_CONFIG,
      params
    }).then(response => transformations.transformSuggestionOptionsResponse(response.data)).catch(ctx.handleApiError),
    getSuggestionLabels: (params: GetSuggestionLabelsParams) => axios.get(`/v4/data-grid/suggestion/${params.suggestId}/labels?${params.keys.map((item, index) => `keys[${index}]=${encodeURIComponent(item)}`).join('&')}`, AXIOS_BASE_CONFIG).then(response => transformations.transformSuggestionLabelsResponse(response.data)).catch(ctx.handleApiError),
    getSmartSearch: () => axios.get(`${BASE_V4_DATAGRID_URL}${ctx.gridCode}/smart-search`, AXIOS_BASE_CONFIG).then(response => transformations.transformSmartSearchResponse(response.data)).catch(ctx.handleApiError)
  };
}